import React from 'react';
import { useDrag } from 'react-dnd';
import { useDispatch } from 'react-redux';
import ComponentItem from 'components/ComponentItem';
import { IComponentItemOwnProps } from 'components/ComponentItem/models';
import { DragSourceType } from 'const';
import { toggleDragState } from 'containers/App/actions';

const CarouselElement: React.FC<IComponentItemOwnProps> = (props) => {
  const dispatch = useDispatch();
  const dragSourceType = DragSourceType.CAROUSEL;
  const [{ isDragging }, dragRef] = useDrag<object, void, { isDragging: boolean }>({
    type: dragSourceType,
    item: () => {
      dispatch(toggleDragState(dragSourceType));

      return {
        type: dragSourceType,
      };
    },
    end: () => {
      dispatch(toggleDragState());
    },
    canDrag() {
      return true; // IN-PROGRESS
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return <ComponentItem {...props} connectDragSource={dragRef} isDragging={isDragging} />;
};

export default CarouselElement;
